<template lang="pug">
  vm-prompt(vm-size="medium" @vm-cancel="close" @vm-accept="saveRecord" @vm-close="close" @vm-action="deleteRecordConfirm(form)" :vm-action="form.deleted_at" :vm-action-text="$t('strings.delete')" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-buttons-hidden="form.deleted_at" :vm-is-valid="!$v.form.$invalid" :vm-active="isModalTrackingGuidesFilesVisible" :vm-title='$t("strings.tracking_guide_files")')
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12" v-shortcuts="[{ shortcut: [ 'enter', ], callback: saveRecord, push: true, focus: true, disabled: $v.form.$invalid },]")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        vm-table.full-width(max-height="350px" :data="trackingGuidesData")
          template(slot="thead")
            vm-th(:key="index" v-for="(column, index) in columns") {{ $t('tracking_guides.' + column) }}
          template(slot-scope="{data}")
            vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
              vm-td(:data="data[indextr][column]" :key="index" v-for="(column, index) in columns")
                slot(v-if="column == 'total' || column == 'amount'")  {{data[indextr][column] | currency }}
                slot(v-if="column == 'created_at'")  {{data[indextr][column] | moment("DD MMMM YYYY") }}
                slot(v-if="column != 'new_weight' && column != 'status' && column != 'created_at' && column !='files'") {{data[indextr][column]}}
                slot(v-if="column == 'files'")
                  vm-td(v-for="(file, fileIndex) in data[indextr]['files']" v-if="file.existsfile" :key="fileIndex")
                    vm-dropdown(vm-custom-content vm-trigger-click vm-trigger-outside-click)
                      vm-button(size="small" icon="eye-outline")

                      vm-dropdown-menu
                        vm-dropdown-item.d-flex.justify-content-between(@click="showFile(file, fileIndex)")
                          vm-icon(icon="download-outline")
                          slot &nbsp;{{ $t('strings.download') }}
                        vm-dropdown-item.d-flex.justify-content-between(v-if="$auth.check('Admin')" @click="deleteTrackigGuideFileConfirm(file, fileIndex)")
                          vm-icon(icon="trash-2-outline")
                          slot &nbsp;{{ $t('strings.delete') }}
        vm-pagination(:total="trackingGuidesPagination.totalPages" v-model="currentPage" goto)
</template>

<script>
import ModalMixin1 from '@/mixins/ModalMixin1'
import { required } from 'vuelidate/lib/validators' // Ver documentacion
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Shipments')

export default {
  name: 'ModalTrackingGuideFiles',
  mixins: [ModalMixin1],
  data: () => ({
    currentPage: 1,
    trackingGuidesData: [],
    columns: [
      'notes',
      'user_display',
      'created_at',
      'files'
    ]
  }),
  validations () {
    return {
      form: {
        name: {
          required
        }
      }
    }
  },
  computed: {
    ...mapGetters(['trackingGuidesPagination', 'isModalTrackingGuidesFilesVisible', 'trackingGuides'])
  },
  watch: {
    currentPage (currentPage) {
      this.loadTrackingGuides({ page: currentPage, shipment_id: this.form.id })
    },
    trackingGuides (list) {
      this.trackingGuidesData = list
    }
  },
  methods: {
    ...mapActions([
      'addRecord',
      'editRecord',
      'deleteRecord',
      'loadTrackingGuides',
      'setModalTrackingGuidesFilesVisible',
      'openFile',
      'deleteTrackingGuideFile',
      'downloadTrackingGuideFile'
    ]),
    close () {
      this.setModalTrackingGuidesFilesVisible(false)
    },
    async showFile (record) {
      await this.openFile(record.public_url)
    },
    deleteTrackigGuideFileConfirm (record) {
      this.auxDeleteRecord = () => {
        this.deleteTrackingGuideFile(record)
        this.loadTrackingGuides({ page: this.currentPage, shipment_id: this.form.id })
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('front.delete_confirmation2', {
          model: this.$t('strings.tracking_guide_file'),
          attribute: this.$t(record.name)
        }),
        accept: this.auxDeleteRecord
      })
    }
  }
}
</script>
